module.exports = __webpack_public_path__ + "static/image/history/pc/201403@3x.ver2_0_2.jpg?5886c4c8";